var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"activite",attrs:{"to":"/Eleve/Travail"}},[_c('div'),_c('h2',[_vm._v(_vm._s(_vm.titre))]),_c('h2',[_vm._v(_vm._s(_vm.description))]),_c('h3',[_vm._v(_vm._s(_vm.note)+"/20")])])}
var staticRenderFns = []

export { render, staticRenderFns }